// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Images/Clinton_Logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider {
  align-self: center;
  border-left: 1px solid white;
  height: 50%;
}
.title-bar-logo {
  background: no-repeat center url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.title-bar-logo:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Components/TitleBar/TitleBar.less"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,4BAAA;EACA,WAAA;AADD;AAIA;EACC,oEAAA;AAFD;AAIC;EACC,eAAA;AAFF","sourcesContent":["@import (reference) \"../../Styles/colors\";\n\n.divider {\n\talign-self: center;\n\tborder-left: 1px solid white;\n\theight: 50%;\n}\n\n.title-bar-logo {\n\tbackground: no-repeat center url(\"../../Images/Clinton_Logo.svg\");\n\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
